module.exports = __webpack_public_path__ + "img/pic-empty-car.0976d5cd.png";